import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Settings, APP_CONFIG } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { OptionModel } from 'src/app/shared/grid/filters/option.model';
import { Observable } from 'rxjs';
import { CandidatePickle } from 'src/app/travelxnew/models/candidate-pickle.model';
import { Pickle } from 'src/app/travelxnew/models/pickle.model';
import { CandidateContract } from 'src/app/travelxnew/models/candidate-contract.model';

@Injectable({
    providedIn: 'root'
})
export class PicklesService {
    private readonly coreApiPath: string;

    constructor(private readonly http: HttpClient, @Inject(APP_CONFIG) settings: Settings) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    getPickleCategories(): Observable<OptionModel[]> {
        return this.http.get<OptionModel[]>(`${this.coreApiPath}/travelx/pickles/categories`);
    }

    getPickleSources() {
        return this.http.get<OptionModel[]>(`${this.coreApiPath}/travelx/pickles/sources`);
    }

    getPickleContractsByCandidateId(candidateId: number) {
        return this.http.get<CandidateContract[]>(`${this.coreApiPath}/travelx/pickles/${candidateId}/contracts`);
    }

    getPicklesForCandidate(candidateId: number): Observable<CandidatePickle[]> {
        return this.http.get<CandidatePickle[]>(`${this.coreApiPath}/travelx/pickles/${candidateId}`);
    }

    submitPickle(candidateId: number, data: Pickle): Observable<any> {
        return this.http.post(`${this.coreApiPath}/travelx/pickles/${candidateId}`, data);
    }

    deletePickle(pickleId: number): Observable<any> {
        return this.http.delete(`${this.coreApiPath}/travelx/pickles/${pickleId}`);
    }
}
